import React, { useState, useMemo, useEffect, useContext } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import MUIDataTable from "components/mui-datatable";
import TableAllData from "components/Content/CustomTable/TableAllData";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import AximTooltip from "components/AximTooltip";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    TextField,
    Typography,
    InputAdornment,
    IconButton
} from "@mui/material";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import { Box } from "@mui/material";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import LoaderAnimation from "pages/LoaderAnimation";
import { Utils } from "common/Utils";
import _ from 'lodash';
import moment from "moment";
import CurrencyFormatter from "components/Formatter/CurrencyFormatter";
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { PropaneSharp } from "@mui/icons-material";
import dayjs from 'dayjs';

const Transition = React.forwardRef(function Transition (props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
export default function ContractSettings ({ isVisible, isAdmin, changeTab, isReadonly }) {
    const { companyId, error } = useContext(PrivateRoutesContext);

    const validationSchema = Yup.object().shape({
        contractName: Yup.string().required('Contract Name is required')
            .max(50, 'Contract Name must not exceed 50 characters'),
        rate: Yup.number().required('Rate is required')
            .min(0, 'Rate cannot be negative'),
        beginDate: Yup.date().default(null)
        .typeError('Invalid Date')
            .required('Begin Date is required'),
        endDate: Yup.date().default(null)
            .required('End Date is required')
            .typeError('Invalid Date')
             .when("beginDate",
                 (beginDate, yup) => {
                    if( beginDate instanceof Date && !isNaN(beginDate)){//invalid date
                        return ( beginDate && yup.min(beginDate, "End Date cannot be before Begin Date"))
                    }
                 })
    });

    const {
        register,
        control,
        handleSubmit,
        reset,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = data => {
        //console.dir(contract)
        if(contract.beginDate!=null){
            contract.beginDate = moment(contract.beginDate).toDate()
        }
        if(contract.endDate!=null){
            contract.endDate = moment(contract.endDate).toDate()
        }
        //console.dir(contract)
        handleSaveContract()
    };

    const [savingData, setSavingData] = React.useState(false)
    const newContract = {
        "contractRateID": Utils.emptyGuid(),
        "contractID": Utils.emptyGuid(),
        "fringeGroupID": Utils.emptyGuid(),
        "contractName": "",
        "contractCode": null,
        "beginDate": null,
        "endDate": null,
        "rate": 0
    };
    const [contract, setContract] = React.useState(newContract);
    const [checkingData, setCheckingData] = useState(true);
    const [openModal, setOpen] = useState(false);
    const [columnsArray, setColumnsArray] = useState([]);
    const [fetchedData, setFetchedData] = useState([]);

    const fetchContracts = (event) => {
        setCheckingData(true);
        
        apiGet(apiUrls.getCompanyContracts(companyId))
            .then((response) => {
                // console.log('fetch contracts')
                // console.dir(response)
                setFetchedData(response.data);
            })
            .catch(function (error) {
                // console.log("THIS IS ERROR", error);
                setColumnsArray([]);
                setFetchedData([]);
            })
            .then(function () {
                // always executed
                setCheckingData(false);
            });
    };
    const handleEdit = (contract) => {
        setOpen(true);
        // console.log('edit')
        // console.log(contract)
        contract.beginDate = moment(contract.beginDate).format("MM/DD/YYYY")
        contract.endDate = moment(contract.endDate).format("MM/DD/YYYY")
        setContract(contract)
        reset(contract)
    }
    const handleClose = () => {
        setOpen(false);
        //setAnchorEl(null);
    };
    
    const showAddModal = () => {
        setContract(newContract);
        setOpen(true);
        reset(newContract)
    };

    const handleContractChange = (propName, propValue) => {
        let obj = { ...contract }
        obj[propName] = propValue
        if (propName == 'contractName') {
            obj['contractCode'] = propValue.replaceAll(' ', '_').substring(0, 50)
        }
        if ((propName == 'beginDate' || propName == 'endDate' ) && propValue=='') {
            obj[propName] = null
        }
        setContract(obj);
        // console.log(propName)
        // console.log(propValue)
        setValue(propName, propValue, { shouldValidate: true })
    };
    
    const handleSaveContract = () => {
        setSavingData(true)
        
        apiPost(apiUrls.postContract(companyId), contract)
            .then((response) => {
                fetchContracts()
                setOpen(false)

            })
            .catch(function (error) {
            })
            .then(function () {
                setSavingData(false)
            });
    };

    useEffect(() => {
        var actionColumn = 
        {
            Header: "Action",
            accessor: (cell) => (
                <IconButton
                    color="primary"
                    aria-label="Edit"
                    component="span"
                    onClick={() => handleEdit(cell)}
                >
                    <EditOutlinedIcon />
                </IconButton>),
            disableFilters: true,
        };

        if (isReadonly && !isAdmin) {
            setColumnsArray(columns);
        }
        else {
            setColumnsArray([actionColumn, ...columns]);
        }
    }, [isVisible, isReadonly, isAdmin]);

    useEffect(() => {
        //fetchTypeOfHours()
        if (isVisible){
            fetchContracts()
        }
    }, [isVisible]);

    let columns = [
        {
            Header: "Contract Name",
            accessor: "contractName",
        },
        {
            Header: "Begin Date",
            accessor: (cell) => Utils.formatDate(cell.beginDate),
            Cell: ({row}) => (
                <Box>
                    {Utils.formatDate(row.original.beginDate)}
                </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: "End Date",
            accessor: (cell) => Utils.formatDate(cell.endDate),
            Cell: ({row}) => (
                <Box>
                    {Utils.formatDate(row.original.endDate)}
                </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: "Rate",
            accessor: (cell) => <CurrencyFormatter value={cell.rate} />
        }
    ];

    const options = {
        filter: true,
        filterType: "dropdown",
        responsive: "standard",
        viewColumns: true,
        download: false,
        print: false,
        textLabels: {
            body: {
                noMatch:
                    fetchedData !== undefined ? (
                        <LoaderAnimation />
                    ) : (
                        "Sorry, there is no data to show"
                    ),
            },
        },
        searchProps: { variant: "standard" }
    };

    return (
        <>
            {/* Add Contract MODAL */}
            <Dialog
                open={openModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={TableStyle.fileTypeModalWrapper}
                fullWidth
            >
                <DialogTitle id="alert-dialog-slide-title">
                    {(contract.contractRateID == Utils.emptyGuid() ? "Add Contract" : "Edit Contract")}
                </DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <div>
                            <TextField
                                {...register('contractName')}
                                label="Contract Name"
                                InputLabelProps={{ shrink: true }}
                                required
                                defaultValue={contract.contractName}
                                id="contractName"
                                name="contractName"
                                value={contract.contractName}
                                variant="standard"
                                onChange={(e) => handleContractChange('contractName', e.target.value)}
                                error={errors.contractName ? true : false}
                                helperText={errors.contractName?.message}
                            />

                            <TextField
                                {...register('rate')}
                                label="Rate"
                                sx={{ m: 1, width: '25ch' }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                }}
                                required
                                defaultValue={contract.rate}
                                value={contract.rate}
                                onChange={(e) => handleContractChange('rate', e.target.value)}
                                id="rate"
                                name="rate"
                                variant="standard"
                                error={errors.rate ? true : false}
                                helperText={errors.rate?.message}
                            />
                        </div>
                        <div>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    {...register('beginDate')}
                                    id="beginDate"
                                    name="beginDate"
                                    minDate={dayjs('01/01/1900')}
                                    value={dayjs(contract.beginDate)}
                                    onChange={(newValue) => handleContractChange('beginDate', newValue?.format('YYYY-MM-DD'))}
                                    label="Begin Date"
                                    slotProps={{
                                      textField: {
                                        helperText: errors.beginDate?.message,
                                      },
                                    }}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                
                            <DatePicker
                                    {...register('endDate')}
                                    id="endDate"
                                    name="endDate"
                                    minDate={dayjs('01/01/1900')}
                                    value={dayjs(contract.endDate)}
                                    onChange={(newValue) => handleContractChange('endDate', newValue?.format('YYYY-MM-DD'))}
                                    label="End Date"
                                    slotProps={{
                                      textField: {
                                        helperText: errors.endDate?.message,
                                      },
                                    }}
                                />
                            </LocalizationProvider>

                        </div>
                    </Box>
                </DialogContent>
                <DialogActions className={ButtonStyle.buttonWrapper}>
                    <Button
                        variant="outlined"
                        onClick={handleSubmit(onSubmit)}
                        disabled={savingData}
                    >
                        {(savingData ? "Saving" : "Save")}
                    </Button>
                    <Button variant="outlined" onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            
            <TableAllData
                className={TableStyle.TimeSheetsWrapper}
                columns={columnsArray}
                data={fetchedData} 
                headerContents={
                    <>
                        <AximTooltip title="View Users" disableFocusListener>
                            <IconButton
                                color="primary"
                                aria-label="View Users"
                                component="span"
                                onClick={() => changeTab('contractUsers')}
                            >
                                <PeopleOutlinedIcon /> 
                            </IconButton>
                        </AximTooltip>
                        {isReadonly && !isAdmin ? null :
                        <>
                            <AximTooltip title="Add Contract" disableFocusListener>
                                <IconButton
                                    color="primary"
                                    aria-label="Add Contract"
                                    component="span"
                                    onClick={showAddModal}
                                >
                                    <AddCircleOutlineOutlinedIcon />
                                </IconButton>
                            </AximTooltip>
                        </>}
                    </>}
            />
        </>
    )
}